import React from 'react';
import List from './List';

const PrimaryFilter = props => {
  const {
    filterData,
    FilterDataObj,
    modifySelectedFilterList,
    currentFilterData,
    userFrameSize,
    dataLocale,
  } = props;
  let childChecker = '';
  return (
    <div className="main-filters">
      <div className="dropdown">
        <div className="grey-bg filterbtn dropdown-toggle" type="button">
          {filterData.name.toUpperCase()}
        </div>
        {/* FilterData.id */}
        <ul className="filter-dropdown-menu list-unstyled menu-lk">
          {filterData.options.map((data, keys) => {
            let checkedOptions = FilterDataObj[filterData.id];
            if (checkedOptions === [] || typeof checkedOptions === 'undefined') {
              checkedOptions = [];
            }
            childChecker = false;
            checkedOptions.forEach(key => {
              if (key.childid === data.id) {
                childChecker = true;
              }
            });
            return (
              <List
                key={keys}
                checkedOptions={childChecker}
                count={data.no_of_products}
                data={data}
                dataLocale={dataLocale}
                filterList={filterData.id}
                handleFunc={(childname, childid) => {
                  childChecker = false;
                  modifySelectedFilterList(childname, childid, currentFilterData);
                }}
                isPrimaryFilter="true"
                userFrameSize={userFrameSize}
              />
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default PrimaryFilter;
